import { render } from "./SpendPerItemCard.vue?vue&type=template&id=56b2301c"
import script from "./SpendPerItemCard.vue?vue&type=script&lang=js"
export * from "./SpendPerItemCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/SpendPerItemCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56b2301c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56b2301c', __exports__)) {
    console.log('reload')
    api.reload('56b2301c', __exports__)
  }
  
  module.hot.accept("./SpendPerItemCard.vue?vue&type=template&id=56b2301c", () => {
    console.log('re-render')
    api.rerender('56b2301c', render)
  })

}


export default __exports__